// ── Pure helper: pick the Polymarket spread that IS a Kalshi line ────
//
// The events map in marketStore groups one Kalshi spread per line per
// event (Kalshi encodes "team X covers" via the YES side of a single
// market), whereas Polymarket exposes one slug per side per line —
// `PM-...-spread-home-5pt5` and `PM-...-spread-away-5pt5` are two
// SEPARATE markets with two SEPARATE asset_id pairs.
//
// The matcher must align on BOTH the exact strike AND the side. Matching
// only magnitude can attach the wrong-side poly book to the Kalshi spread
// row — the user clicks "LAL covers -5.5" and the modal sends a token
// for "BOS covers +5.5" instead, a different bet entirely. Matching a
// NEARBY strike is the same class of error: 5.25, 5.75 and 5 have different
// declared strikes from 5.5. Settlement equivalence cannot be inferred by
// proximity. The old ±0.25 join attached whichever
// neighbor the feed listed first and hid the exact market it displaced.
// Strikes are compared exactly, AFTER each venue's own settlement
// conversion (Kalshi `floorStrike` / subtitle / `bucket − 0.5`; Polymarket
// slug `5pt5` → 5.5); an unmatched Polymarket line becomes its own row in
// getGameEvents rather than a stand-in for someone else's.
//
// `favored` is the Kalshi side that's covering (the YES outcome of
// the Kalshi spread market). Pick the poly spread whose slug side
// matches — i.e. `spread-away` for an away-favored Kalshi spread.

export interface PolySpread {
  ticker: string;
  line: number;
  side: 'home' | 'away';
}

export function matchPolySpread(
  polySpreads: ReadonlyArray<PolySpread>,
  lineMag: number,
  favored: 'home' | 'away',
): PolySpread | undefined {
  if (!Number.isFinite(lineMag)) return undefined;
  return polySpreads.find((p) => p.side === favored && p.line === lineMag);
}
